'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _overlay = require('@alicd/next/lib/overlay');

var _overlay2 = _interopRequireDefault(_overlay);

var _icon = require('@alicd/next/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _nextDom = require('@alicd/next-dom');

var _onfire = require('onfire.js');

var _onfire2 = _interopRequireDefault(_onfire);

var _localeProvider = require('@alicd/next/lib/locale-provider');

var _localeProvider2 = _interopRequireDefault(_localeProvider);

var _index = require('./local/index.js');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var leavingReg = /^modal\-leave\-level\-/;

var hasScroll = function hasScroll() {
    var doc = document.documentElement;
    return doc.scrollHeight > doc.clientHeight && scrollbar().width > 0;
};

var InterDialog = function (_React$Component) {
    (0, _inherits3.default)(InterDialog, _React$Component);

    function InterDialog(props, context) {
        (0, _classCallCheck3.default)(this, InterDialog);

        var _this = (0, _possibleConstructorReturn3.default)(this, (InterDialog.__proto__ || (0, _getPrototypeOf2.default)(InterDialog)).call(this, props, context));

        _this.state = {
            visible: false,
            containerClassName: '',
            testVisible: false
        };
        _this.modalIndex = 0;
        _this._beforeOpen = _this._beforeOpen.bind(_this);

        _this.addModalListener = _onfire2.default.on('add-modal', function (number) {
            var index = InterDialog.modalIndexArray.indexOf(_this.modalIndex);
            if (number > index) {
                if (!leavingReg.test(_this.containerClassName) && _this.state.visible) {
                    _this.setState({
                        containerClassName: 'modal-backward-level-' + (number - index)
                    });
                    _this.state.containerClassName = 'modal-backward-level-' + (number - index);
                } else {}
            }
        });
        _this.removeModalListener = _onfire2.default.on('remove-modal', function (number) {
            var index = InterDialog.modalIndexArray.indexOf(_this.modalIndex);
            if (number > index) {
                _this.setState({
                    containerClassName: 'modal-forward-level-' + (number - index)
                });
                _this.state.containerClassName = 'modal-forward-level-' + (number - index);
            }
        });
        return _this;
    }

    (0, _createClass3.default)(InterDialog, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.visible) {
                this.addBlurToRoot();
                _onfire2.default.fire('add-modal', InterDialog.modalIndexArray.length);
                this.modalIndex = Date.now() + '' + Math.floor(Math.random() * 10000);
                InterDialog.modalIndexArray.push(this.modalIndex);
                this.state.visible = true;
                this.setState({
                    visible: true,
                    containerClassName: this.modalIndex === 0 ? 'modal-first-enter' : 'modal-enter' // 防止由于不是第一次弹框造成的影响
                });
                this.containerClassName = this.modalIndex === 0 ? 'modal-first-enter' : 'modal-enter';
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this._beforeOpen();
        }
    }, {
        key: '_beforeOpen',
        value: function _beforeOpen() {
            if (this.props.disableScroll && this.props.visible) {
                this.bodyOverflowY = document.body.style.overflowY;
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _onfire2.default.un(this.addModalListener);
            _onfire2.default.un(this.removeModalListener);
        }
    }, {
        key: 'addBlurToRoot',
        value: function addBlurToRoot() {
            if (!!document.getElementById(this.props.root) && !this.props.disabledBackgroundBlur) document.getElementById(this.props.root).classList.add('animation-blur');
        }
    }, {
        key: 'removeBlurToRoot',
        value: function removeBlurToRoot() {
            if (!!document.getElementById(this.props.root) && !this.props.disabledBackgroundBlur) document.getElementById(this.props.root).classList.remove('animation-blur');
        }

        /**
         当切换弹框并且上一个弹框需要消失的时候，调度队列:
          |------ 下一个弹框visible变为true的处理逻辑 ------|------ 上一个弹框visible变为true的处理逻辑 ------|------ onfire接收到add-modal ------|------ onfire接收到remove-modal ------|
                                      |                                             |
                                触发add-modal                                 触发remove-modal
          由于setState机制的异步操作问题会给事件调度管理增加难度,所以我们采用this.containerClassName来同步管理方便调度,并且通过setState的特性来触发render
         */

    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var _this2 = this;

            if (!this.state.visible && props.visible) {
                this.addBlurToRoot();
                _onfire2.default.fire('add-modal', InterDialog.modalIndexArray.length);
                this.modalIndex = Date.now() + '' + Math.floor(Math.random() * 10000);
                InterDialog.modalIndexArray.push(this.modalIndex);
                this.setState({
                    visible: true,
                    containerClassName: this.modalIndex === 0 ? 'modal-first-enter' : 'modal-enter' // 防止由于不是第一次弹框造成的影响
                });
                this.containerClassName = this.modalIndex === 0 ? 'modal-first-enter' : 'modal-enter';
            } else if (this.state.visible && !props.visible) {
                setTimeout(function () {
                    // 这里setTimeout的作用:等待别的组件的上一个if的部分先执行完毕
                    var index = InterDialog.modalIndexArray.indexOf(_this2.modalIndex);
                    var len = InterDialog.modalIndexArray.length;
                    if (index !== len - 1) {
                        _this2.setState({
                            containerClassName: 'modal-leave-level-' + (len - 1 - index)
                        });
                        _this2.containerClassName = 'modal-leave-level-' + (len - 1 - index);
                        setTimeout(function () {
                            _this2.setState({
                                visible: false
                            });
                            InterDialog.modalIndexArray.splice(index, 1);
                        }, _this2.props.animationTime);
                    } else {
                        if (len - 1 === 0) _this2.removeBlurToRoot();
                        _onfire2.default.fire('remove-modal', len - 1); // 减1是因为,当前待删除的还没有删除
                        InterDialog.modalIndexArray.splice(index, 1);
                        _this2.setState({
                            visible: false
                        }, function () {});
                    }
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                style = _props.style,
                className = _props.className,
                locale = _props.locale,
                width = _props.width,
                height = _props.height,
                _onClose = _props.onClose,
                onCancel = _props.onCancel,
                onOk = _props.onOk,
                onDelete = _props.onDelete,
                visible = _props.visible,
                _onRequestClose = _props.onRequestClose,
                okText = _props.okText,
                deleteText = _props.deleteText,
                cancelText = _props.cancelText,
                title = _props.title,
                footer = _props.footer,
                header = _props.header,
                others = (0, _objectWithoutProperties3.default)(_props, ['style', 'className', 'locale', 'width', 'height', 'onClose', 'onCancel', 'onOk', 'onDelete', 'visible', 'onRequestClose', 'okText', 'deleteText', 'cancelText', 'title', 'footer', 'header']);


            var containerStyle = {
                width: width ? width : "",
                height: height ? height : ""
            };

            var innerMinHeightFooterPart = footer !== false ? 60 : 0;
            var innerMinHeight = header !== false ? height - 80 - innerMinHeightFooterPart : height - innerMinHeightFooterPart;

            return _react2.default.createElement(
                _overlay2.default,
                (0, _extends3.default)({}, others, {
                    animation: false,
                    visible: this.state.visible,
                    onRequestClose: function onRequestClose(reason) {
                        if (reason === 'maskClick') {
                            // 如果我们配置了canCloseByMask为false,这种情况就直接不会触发,所以这里不用做过多判断
                            if (InterDialog.modalIndexArray.indexOf(_this3.modalIndex) === InterDialog.modalIndexArray.length - 1) {
                                if (_onRequestClose) _onRequestClose();
                            }
                        } else if (!reason) {
                            // 没有原因的情况应该是直接点击取消或者关闭
                            if (_onRequestClose) _onRequestClose();
                        }
                    },
                    onClose: function onClose(e) {
                        document.body.style['overflow-y'] = null;
                        if (_onClose) _onClose();
                    } }),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)("cn-inter-modal-container", this.state.containerClassName, className),
                        style: (0, _extends3.default)({}, containerStyle, style)
                    },
                    header === false ? null : header ? header : _react2.default.createElement(
                        'div',
                        { className: 'Modal-header' },
                        _react2.default.createElement(
                            'h4',
                            { className: 'Modal-title' },
                            !!title ? title : null
                        ),
                        this.props.setting !== false ? this.props.setting ? this.props.setting : !this.props.hasClose ? null : _react2.default.createElement(_icon2.default, { type: 'close', onClick: function onClick() {
                                if (_this3.props.onRequestClose) _this3.props.onRequestClose();
                            } }) : null
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cn-inter-modal-content', style: { minHeight: innerMinHeight } },
                        this.props.children
                    ),
                    footer === false ? null : footer ? footer : // footer部分可以自定义
                    _react2.default.createElement(
                        'div',
                        { className: 'Modal-footer' },
                        !onOk ? "" : _react2.default.createElement(
                            'button',
                            { className: 'button-dark',
                                onClick: function onClick() {
                                    if (onOk) onOk();
                                }
                            },
                            !!okText ? okText : locale.ok
                        ),
                        !onDelete ? "" : _react2.default.createElement(
                            'button',
                            { className: 'button-danger',
                                onClick: function onClick() {
                                    if (onDelete) onDelete();
                                }
                            },
                            !!deleteText ? deleteText : locale.delete
                        ),
                        !onCancel ? "" : _react2.default.createElement(
                            'button',
                            { className: 'button-light',
                                onClick: function onClick() {
                                    if (onCancel) onCancel();
                                }
                            },
                            !!cancelText ? cancelText : locale.cancel
                        )
                    )
                )
            );
        }
    }]);
    return InterDialog;
}(_react2.default.Component);

InterDialog.propTypes = {
    root: _propTypes2.default.string,
    style: _propTypes2.default.object,
    className: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    onClose: _propTypes2.default.func,
    onCancel: _propTypes2.default.func,
    onOk: _propTypes2.default.func,
    onDelete: _propTypes2.default.func,
    visible: _propTypes2.default.bool,
    onRequestClose: _propTypes2.default.func,
    okText: _propTypes2.default.string,
    deleteText: _propTypes2.default.string,
    cancelText: _propTypes2.default.string,
    title: _propTypes2.default.string,
    footer: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.bool, _propTypes2.default.string]),
    header: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.bool, _propTypes2.default.string]),
    animationTime: _propTypes2.default.number,
    hasClose: _propTypes2.default.bool,
    disabledBackgroundBlur: _propTypes2.default.bool,
    setting: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool])
};
InterDialog.defaultProps = {
    root: 'root',
    style: {},
    className: '',
    align: 'cc cc',
    onClose: null,
    onOk: null,
    onDelete: null,
    onCancel: null,
    visible: false,
    hasMask: true,
    onRequestClose: null,
    okText: null,
    deleteText: null,
    cancelText: null,
    title: null,
    footer: null,
    header: null,
    animationTime: 400,
    hasClose: true,
    disabledBackgroundBlur: false,
    setting: null
};


InterDialog.modalIndexArray = [];

var LocaleInterDialog = (0, _localeProvider2.default)(InterDialog);
LocaleInterDialog.LOCALE = _index2.default;

exports.default = LocaleInterDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-inter-dialog@0.0.46@@alicd/crui-inter-dialog/lib/InterDialog.js
// module id = 107
// module chunks = 0